import { RootState } from '@redux/types';

export const roomIdSelector = (state: RootState) => state.room.roomId;
export const roomUuidSelector = (state: RootState) => state.room.roomUuid;
export const bamIdSelector = (state: RootState) => state.room.bamRoomId;
export const roomCountrySelector = (state: RootState) => state.room.roomCountry;
export const roomNameSelector = (state: RootState) => state.room.roomName;

export const roomSelector = (state: RootState) => state.room;
